import { createBrowserRouter, RouterProvider, } from "react-router-dom";
import { lazy, Suspense } from "react";
import Layout from '@/layouts/Layout.tsx'
import LogInPage from "./pages/login/Login";
import RegisterPage from "./pages/login/Register";
import PrivateRoute from '@/components/PrivateRoute'
import ProgramGateway from '@/components/ProgramGateway'
import OverviewPage from "./pages/overview/Page";
import ResetPasswordPage from "./pages/reset-password/ResetPasswordPage";
import ForgotPasswordPage from "./pages/forgot-password/ForgotPasswordPage";
import SettingsPage from "./pages/settings/Settings";
import ProfilePage from "./pages/profile/Profile";
import RouteErrorBoundary from "./components/errors/RouteErrorBoundary";
// Lazy load the Users page to reduce main bundle size
const UsersPage = lazy(() => import("./pages/users/Users"));
const UserDetailPage = lazy(() => import("./pages/users/UserDetailPage"));
const RewardsPage = lazy(() => import("./pages/rewards/Page"));
const CustomersPage = lazy(() => import("./pages/customer/Customers"));
const RewardClaimsPage = lazy(() => import("./pages/rewards-claims/RewardClaims"));
const ClaimDetailPage = lazy(() => import("./pages/rewards-claims/DetailPage"));
const PayoutsPage = lazy(() => import("./pages/payouts/Page"));
const PayoutBatchDetailPage = lazy(() => import("./pages/payouts/DetailPage"));
const BenchmarkPricePage = lazy(() => import("./pages/benchmark/BenchmarkPrice"));
const ActivateAccountPage = lazy(() => import("./pages/customer/ActivateAccount"));
const SelectProgramPage = lazy(() => import("./pages/program/SelectProgram"));
const CompleteProfilePage = lazy(() => import("./pages/program/CompleteProfile"));
const PersonsPage = lazy(() => import("./pages/persons/Persons"));
const SpifTermsPage = lazy(() => import("./pages/terms/SpifTerms"));
export const router = createBrowserRouter([
    {
        path: '/login',
        element: <LogInPage />
    },
    {
        path: '/register',
        element: <RegisterPage />
    },
    {
        path: '/forgot-password',
        element: <ForgotPasswordPage />
    },
    {
        path: '/reset-password',
        element: <ResetPasswordPage />
    },
    {
        path: '/activate-account',
        element: <ActivateAccountPage />
    },
    {
        path: '/spif-terms',
        element: (
            <Suspense fallback={
                <div className="flex items-center justify-center h-64">
                    <div className="h-8 w-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                </div>
            }>
                <SpifTermsPage />
            </Suspense>
        )
    },
    {
        path: '/',
        element: <PrivateRoute />,
        errorElement: <RouteErrorBoundary />,
        children: [
            {
                path: 'select-program',
                element: (
                    <Suspense fallback={
                        <div className="flex items-center justify-center h-64">
                            <div className="h-8 w-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                        </div>
                    }>
                        <SelectProgramPage />
                    </Suspense>
                )
            },
            {
                path: '',
                element: <ProgramGateway />,
                children: [
                    {
                        path: 'complete-profile',
                        element: (
                            <Suspense fallback={
                                <div className="flex items-center justify-center h-64">
                                    <div className="h-8 w-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                                </div>
                            }>
                                <CompleteProfilePage />
                            </Suspense>
                        )
                    },
                    {
                        path: '',
                        element: <Layout />,
                        children: [
                            {
                                path: 'profile', element: <ProfilePage />
                            },
                            {
                                path: 'overview', element: <OverviewPage />
                            },
                            {
                                path: 'rewards',
                                element: (
                                    <Suspense fallback={
                                        <div className="flex items-center justify-center h-64">
                                            <div className="h-8 w-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                                        </div>
                                    }>
                                        <RewardsPage />
                                    </Suspense>
                                )
                            },
                            { path: 'settings', element: <SettingsPage /> },
                            {
                                path: 'customers',
                                element: (
                                    <Suspense fallback={
                                        <div className="flex items-center justify-center h-64">
                                            <div className="h-8 w-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                                        </div>
                                    }>
                                        <CustomersPage />
                                    </Suspense>
                                )
                            },
                            {
                                path: 'users',
                                element: (
                                    <Suspense fallback={
                                        <div className="flex items-center justify-center h-64">
                                            <div className="h-8 w-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                                        </div>
                                    }>
                                        <UsersPage />
                                    </Suspense>
                                )
                            },
                            {
                                path: 'persons',
                                element: (
                                    <Suspense fallback={
                                        <div className="flex items-center justify-center h-64">
                                            <div className="h-8 w-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                                        </div>
                                    }>
                                        <PersonsPage />
                                    </Suspense>
                                )
                            },
                            {
                                path: 'users/:userId',
                                element: (
                                    <Suspense fallback={
                                        <div className="flex items-center justify-center h-64">
                                            <div className="h-8 w-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                                        </div>
                                    }>
                                        <UserDetailPage />
                                    </Suspense>
                                )
                            },
                            {
                                path: 'rewards-claims',
                                element: (
                                    <Suspense fallback={
                                        <div className="flex items-center justify-center h-64">
                                            <div className="h-8 w-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                                        </div>
                                    }>
                                        <RewardClaimsPage />
                                    </Suspense>
                                )
                            },
                            {
                                path: 'rewards-claims/:claimId',
                                element: (
                                    <Suspense fallback={
                                        <div className="flex items-center justify-center h-64">
                                            <div className="h-8 w-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                                        </div>
                                    }>
                                        <ClaimDetailPage />
                                    </Suspense>
                                )
                            },
                            {
                                path: 'payouts',
                                element: (
                                    <Suspense fallback={
                                        <div className="flex items-center justify-center h-64">
                                            <div className="h-8 w-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                                        </div>
                                    }>
                                        <PayoutsPage />
                                    </Suspense>
                                )
                            },
                            {
                                path: 'payouts/:batchId',
                                element: (
                                    <Suspense fallback={
                                        <div className="flex items-center justify-center h-64">
                                            <div className="h-8 w-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                                        </div>
                                    }>
                                        <PayoutBatchDetailPage />
                                    </Suspense>
                                )
                            },
                            {
                                path: 'benchmark-prices',
                                element: (
                                    <Suspense fallback={
                                        <div className="flex items-center justify-center h-64">
                                            <div className="h-8 w-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                                        </div>
                                    }>
                                        <BenchmarkPricePage />
                                    </Suspense>
                                )
                            },
                        ]
                    }
                ]
            }
        ]
    },
]);

function Routes() {
    return (
        <RouterProvider router={router} />
    );
}

export default Routes;
